export default "/react/logoWidster-4baa3221.png";